import * as React from "react";
import {useState} from "react";
import DocUpload from "myshubhlife-component/docInput";
import MultiDocUpload from "myshubhlife-component/multiple-doc-upload";
import {currentAddressProofOptions, DOC_TYPE, UPLOAD_SIDE} from "loan-application/application/doc-upload/utils";
import SelfieCapture from "selfie";
import {DocTypes} from "userform/utils";
import {imageBaseUrl} from "config";
import {ACCEPT_TYPE} from "utils/variables";
import {isMobileOrTab} from "utils";
interface IProps {
    label: string;
    handleChange: (fileName, value) => void;
    index?: number;
    identifier: string[];
    errorMsg?: object;
    uploaded?: any;
    isAndroid?: boolean;
    apiVersion?: number;
}
const DocUploadComposer = (props: IProps) => {
    const handleFileUpload = (base64, docType) => {
        props.handleChange(docType, base64);
    };
    const renderErrorMsg = (msg: string) => {
        return(<p className="inline-error-msg">{msg}</p>);
    };

    return(
        <React.Fragment>
            <label className="doc-container-label">{props.label}</label>
            {
                props.identifier.length > 0 && props.identifier.map((name, index) => {
                    if (name === DOC_TYPE.CURRENT_ADDRESS_PROOF) {
                        return(
                            <div className="doc-upload-container" key={index}>
                                <MultiDocUpload
                                    fileName= {name}
                                    primaryLabel={"CURRENT ADDRESS PROOF"}
                                    secondaryLabel={"Please upload both side"}
                                    uploadSide= {[UPLOAD_SIDE.FRONT, UPLOAD_SIDE.BACK]}
                                    getPdfBase64= {handleFileUpload}
                                    docOptions={currentAddressProofOptions}
                                    isUploaded={props.uploaded && props.uploaded.includes(name)}
                                    compressionRequired={true}
                                />
                                {
                                    props.errorMsg && props.errorMsg.hasOwnProperty(name) &&
                                    renderErrorMsg(props.errorMsg[name])
                                }
                            </div>
                        );
                    } else if (name === DOC_TYPE.SELFIE && !props.isAndroid && !isMobileOrTab()) {
                        return (
                            <div className="doc-upload-container" key={index}>
                                <SelfieCapture
                                    onSubmit={(base64) => handleFileUpload(base64, DocTypes.SELFIE)}
                                    errorMsg={props.errorMsg && props.errorMsg.hasOwnProperty(name) && props.errorMsg[name]}
                                    uploaded={props.uploaded && props.uploaded.includes(name)}
                                />
                            </div>
                        );
                    } else {
                        return(
                            <div className="doc-upload-container" key={index}>
                                <DocUpload
                                    type={name}
                                    primaryLabel={name}
                                    handleFileInput={handleFileUpload}
                                    isUploaded={props.uploaded && props.uploaded.includes(name)}
                                    compressionRequired={true}
                                    acceptType={name === DOC_TYPE.SELFIE ? `${ACCEPT_TYPE.ALL_IMAGE}` : `${ACCEPT_TYPE.PDF},${ACCEPT_TYPE.ALL_IMAGE}`}
                                    captureType={name === DOC_TYPE.SELFIE ? "camera" : null}
                                />
                                {
                                    props.errorMsg && props.errorMsg.hasOwnProperty(name) &&
                                    renderErrorMsg(props.errorMsg[name])
                                }
                            </div>
                        );
                    }
                })
            }
        </React.Fragment>
    );
};

export default DocUploadComposer;
